/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($contentDetailId: ID!, $isPremium: String!) {
    UpdatePremium(contentDetailId: $contentDetailId, isPremium: $isPremium) {
      status
      message
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
